import api from "@/api";
import { jwtDecode } from "jwt-decode";
import { $t } from "@/i18n";
import {
	getLocalStorageReac,
	getSessionStorageReac,
	setLocalStorageReac,
	setSessionStorageReac,
} from "@/assets/js/helpers";
// import { useToastStore } from "./toast";
import { useDefaultStore } from "@/store";
import { useToast } from "primevue/usetoast";
// import { baseURL } from "@/api/config";
import type { TUserData, TLoginParam } from "@/api/types";

export const useSessionStore = defineStore("session", () => {
	const router = useRouter();
	const userToken = ref("");
	const userData = ref<TUserData | null>();
	const tokenRefreshTimeout = ref<ReturnType<typeof setTimeout> | null>(null);
	const isBusyRenewalToken = ref(false);
	const toast = useToast();
	const store = useDefaultStore();

	const isLoggedIn = computed(() => !!userToken.value);
	const isUserSuperAdmin = computed(() =>
		userData.value?.roles.includes(store.roles[0].rol_id),
	);
	const userPermissions = computed<string[]>(
		() => userData.value?.permissions || [],
	);
	// const userImage = computed(() => {
	// 	return getImageUrl(userData.value?.img_id);
	// });
	// function getImageUrl(imageId?: number | string): string | null {
	// 	if (imageId) {
	// 		return `${baseURL}/users/images-get/${imageId}`;
	// 	}
	// 	return null;
	// }
	function saveToken(token: string, isRemember = false) {
		userToken.value = token;
		userData.value = token ? jwtDecode(token) : null;

		if (token) {
			if (isRemember) {
				setLocalStorageReac("user-token", token);
			} else {
				setSessionStorageReac("user-token", token);
			}
		} else {
			const sesToken = getSessionStorageReac("user-token");
			const locToken = getLocalStorageReac("user-token");
			sesToken.value = null;
			locToken.value = null;
		}

		// todo ovde napravi logiku za izbacivanje
	}
	async function loadSessionToken() {
		const sesToken =
			(getSessionStorageReac("user-token").value as string) || "";
		const locToken = (getLocalStorageReac("user-token").value as string) || "";

		const loadSession = async (token: string) => {
			if (typeof token === "string") {
				console.log("2 - da li sam ja lud");
				saveToken(token);
				if (!tokenRefreshTimeout.value) {
					await setupTokenRenewal(true);
				}
			} else {
				console.error("Invalid token format", token);
			}
		};

		if (sesToken) {
			await loadSession(sesToken);
		} else if (locToken) {
			await loadSession(locToken);
		}
	}

	async function setupTokenRenewal(isRefreshToken = false, debug = true) {
		if (isBusyRenewalToken.value) {
			// console.warn(":: Busy token, exiting");
			return;
		}

		isBusyRenewalToken.value = true;
		tokenRefreshTimeout.value && clearTimeout(tokenRefreshTimeout.value);
		tokenRefreshTimeout.value = null;

		if (isRefreshToken) {
			await renewToken();
		}

		const TIME_TO_REFRESH = 15 * 60 * 1000;
		if (debug) {
			console.log(
				`:: Setup token refresh - ${TIME_TO_REFRESH / 60 / 1000}min`,
				isRefreshToken,
			);
		}
		tokenRefreshTimeout.value = setTimeout(() => {
			void setupTokenRenewal(true);
		}, TIME_TO_REFRESH);
		isBusyRenewalToken.value = false;
	}
	function cancelRenewToken() {
		if (tokenRefreshTimeout.value) {
			clearTimeout(tokenRefreshTimeout.value);
			tokenRefreshTimeout.value = null;
		}
	}
	async function renewToken() {
		if (!userToken.value && tokenRefreshTimeout.value) {
			return;
		}

		try {
			const res = await api.authCheckJwt();
			console.log(res.data.data);
			const token = res.data.data.token;

			console.log(":: Token refreshed");
			saveToken(token);
		} catch {
			// ignored
		}
	}

	async function setupLogin(payload: TLoginParam, isRemember = false) {
		try {
			const res = await api.authLogin(payload);
			console.log(res.data.data);
			saveToken(res.data.data.token, isRemember);
			return true;
		} catch (err: any) {
			if (err.response.data.message.includes("Account is suspended.")) {
				toast.add({
					severity: "error",
					summary: $t("app.auth.error.accSuspended.title"),
					detail: $t("app.auth.error.accSuspended.msg"),
					life: 3000,
				});
			} else {
				toast.add({
					severity: "error",
					summary: $t("app.auth.error.invalidCredentials.title"),
					detail: $t("app.auth.error.invalidCredentials.msg"),
					life: 3000,
				});
			}
			console.warn(err.message);
			return false;
		}
	}
	async function logoutApi(
		showMsg = false,
		shouldRedirect = true,
	): Promise<boolean> {
		const checkRedirectUser = () => {
			if (shouldRedirect) {
				void router.replace("/");
			}
		};

		if (!userToken.value) {
			console.warn(":: User already logged out");
			// useToastStore().openToastWarning("User already logged out");
			checkRedirectUser();
			return false;
		}
		try {
			await api.authLogout();
			cancelRenewToken();

			if (showMsg) {
				// useToastStore().openToastInfo("User logged out");
				console.warn("User logged out");
			}

			checkRedirectUser();

			return true;
		} catch {
			return false;
		} finally {
			saveToken("", false);
		}
	}

	/**
	 * This function is used to check if the current user has specific permission
	 */
	function can(...keys: string[]) {
		return true;
		// return keys.every((key) => userPermissions.value.includes(key));
	}

	return {
		isLoggedIn,
		isUserSuperAdmin,
		userData,
		// userImage,
		can,
		setupLogin,
		saveToken,
		loadSessionToken,
		setupTokenRenewal,
		logoutApi,
		// getImageUrl,
		renewToken,
	};
});
